"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENTS = {
    PLAYING: 'playing',
    PAUSED: 'paused',
    ENDED: 'ended',
};
exports.PROGRESS_INTERVAL = 1000;
//# sourceMappingURL=constants.js.map